import request from '../utils/request.js'

// 获取个性模板图片列表
export function getBackimgs () {
  return request({
    url: '/api/v1/backimgs',
    method: 'get'
  })
}
// 作者作品列表（上拉分页）
export function getMyBooks(params) {
  return request({
    url: '/api/v1/book/list',
    method: 'get',
    params
  })
}
// 发布作品（作者）
export function publishBook (data) {
  return request({
    url: '/api/v1/book/publish',
    method: 'post',
    data
  })
}

// 公共图片上传（免费/付费内容图片复用）
export function uploadImage (formData) {
  return request({
    url: '/api/v1/upload/image',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

// 获取资料信息（ap_book）
export function pubDetail (proId) {
  const id = proId == null ? '' : String(proId)
  return request({
    url: '/api/v1/book/pubDetail?proId=' + encodeURIComponent(id),
    method: 'post'
  })
}

// 编辑作品基础信息（标题/简介/售价）
export function saveBookEdit (data) {
  return request({
    url: '/api/v1/book/edit/save',
    method: 'post',
    data
  })
}

// 获取资料信息 + 内容详情（免费内容 + 付费内容）
export function detailLiao (proId) {
  const id = proId == null ? '' : String(proId)
  return request({
    url: '/api/v1/book/detailLiao?proId=' + encodeURIComponent(id),
    method: 'post'
  })
}

// 设置隐藏并定时发单时间（支持 13位时间戳/ISO/相对时间）
export function setHidetime (params) {
  return request({
    url: '/api/v1/book/setHidetime',
    method: 'get',
    params
  })
}

// 设置定时通知时间（支持 13位时间戳/ISO/相对时间）
export function setNoticetime (params) {
  return request({
    url: '/api/v1/book/setNoticetime',
    method: 'get',
    params
  })
}

// 追加/编辑免费内容（作者端）
export function saveFreeContent (data) {
  return request({
    url: '/api/v1/book/content/free/save',
    method: 'post',
    data
  })
}

// 追加付费内容（作者端）
export function addPaidContent (data) {
  return request({
    url: '/api/v1/book/content/paid/add',
    method: 'post',
    data
  })
}

// 编辑付费内容（作者端）
export function updatePaidContent (data) {
  return request({
    url: '/api/v1/book/content/paid/update',
    method: 'post',
    data
  })
}

// 删除内容（按 ap_content.id）
export function deleteBookContent (data) {
  return request({
    url: '/api/v1/book/content/delete',
    method: 'post',
    data
  })
}

// 上一篇/下一篇
export function adjacentBook (params) {
  return request({
    url: '/api/v1/book/adjacent',
    method: 'get',
    params
  })
}


// 置顶/取消置顶 flag: 1=置顶 0=取消
export function setBookTop(data) {
  return request({
    url: '/api/v1/book/top',
    method: 'post',
    data
  })
}

// 上架/下架 flag: 1=下架 0=上架
export function setBookShelf(data) {
  return request({
    url: '/api/v1/book/shelf',
    method: 'post',
    data
  })
}

// 公开/取消公开 flag: 1=公开 0=取消公开（未公开）
export function setBookOpen(data) {
  return request({
    url: '/api/v1/book/open',
    method: 'post',
    data
  })
}

// 设置权重（sorts） value: 0-999
export function setBookSorts(data) {
  return request({
    url: '/api/v1/book/sorts',
    method: 'post',
    data
  })
}

// 加标签（determine）
export function setBookDetermine(data) {
  return request({
    url: '/api/v1/book/determine',
    method: 'post',
    data
  })
}

// 删除作品（作者端）
export function deleteMyBook(data) {
  return request({
    url: '/api/v1/book/delete',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/book.js